<template>
    <swipeModal v-model="isDrawerOpen" contents-height="auto" contents-width="auto" border-top-radius="20px"
        tip-color="#DEDEDE" :persistent="isPersistent" :class="{ persistent: isPersistent }" :is-drag-handle="false">
        <component class="drawer-container" :is="drawer" @closeDrawer="handleCloseDrawer"></component>
    </swipeModal>
</template>

<script>
import { markRaw } from '@vue/composition-api';
import { mapState } from 'vuex';
import swipeModal from '@takuma-ru/vue-swipe-modal';
import GenericInfoDrawer from '@/components/receipt-upload/GenericInfoDrawer.vue';
import UploadReceiptGuidelinesDrawer from '@/components/receipt-upload/UploadReceiptGuidelinesDrawer.vue';
import AllowEmailRequiredDrawer from '@/components/authentication/AllowEmailRequiredDrawer.vue';
import IncompleteProfileDrawer from '@/components/authentication/IncompleteProfileDrawer.vue';
import { has } from 'lodash';

export default {
    name: "SwipeModalComponent",
    components: {
        swipeModal
    },
    data() {
        return {
            drawer: null
        }
    },
    computed: {
        ...mapState("utilityStore", {
            isDrawerOpen: (state) => state.isDrawerOpen,
            drawerComponent: (state) => state.drawerComponent,
            drawerData: (state) => state.drawerData,
        }),
        isPersistent: {
            get() {
                if (this.drawerData && has(this.drawerData, 'isPersistent')) {
                    return this.drawerData.isPersistent;
                }
                return false;
            },
            set(value) {
                return value;
            }
        }
    },
    mounted() {
        this.$root.$on('closeDrawer', () => this.handleCloseDrawer());
    },
    beforeDestroy() {
        this.$root.$off('closeDrawer');
    },
    methods: {
        animateDrawerClosing() {
            document.documentElement
                .querySelector('.swipe-modal-takumaru-vue-swipe-modal')
                .classList.remove('shown')
            setTimeout(() => this.$store.commit('utilityStore/closeDrawer'), 300);
        },
        handleCloseDrawer() {
            document.documentElement.style.setProperty('overflow-y', null);
            this.animateDrawerClosing();
        }
    },
    watch: {
        isDrawerOpen(isOpen) {
            const components = {
                GenericInfoDrawer,
                UploadReceiptGuidelinesDrawer,
                AllowEmailRequiredDrawer,
                IncompleteProfileDrawer
            };

            if (this.drawerComponent && this.drawerComponent in components)
                this.drawer = markRaw(components[this.drawerComponent]);
            else this.drawer = null;

            if (isOpen) {
                document.documentElement.style.setProperty('overflow', 'hidden');
                setTimeout(() => {
                    document.documentElement
                        .querySelector('.swipe-modal-takumaru-vue-swipe-modal')
                        .classList.add('shown');
                }, 100);

                this.$nextTick(() => {
                    if (this.isPersistent) {
                        const closeDrawer = document.querySelector('.modal-contents-chip-wrapper');

                        if (this.drawerComponent === 'GenericInfoDrawer' || this.drawerComponent === 'UploadReceiptGuidelinesDrawer' || this.drawerComponent === 'AllowEmailRequiredDrawer' || this.drawerComponent === 'IncompleteProfileDrawer') closeDrawer.remove();

                        closeDrawer.addEventListener('click', () => this.handleCloseDrawer());
                    } else {
                        const drawerBackDrop = document.querySelector('.modal-background');

                        drawerBackDrop.addEventListener('click', () => this.handleCloseDrawer());
                    }
                })
            } else {
                if (this.isPersistent)
                    this.$nextTick(() => this.$store.commit('utilityStore/openDrawer', (this.drawerComponent, this.drawerData)));

                document.documentElement.style.setProperty('overflow', 'auto');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.drawer-container {
    padding-top: 40px;
    width: 100vw;
    max-width: 600px;
}
</style>

<style lang="scss">
.swipe-modal-takumaru-vue-swipe-modal {
    z-index: 1031 !important;

    .modal-contents {
        max-width: 600px;
        width: 100vw !important;
        bottom: -100% !important;
        transition: bottom ease-in-out 0.3s !important;
    }

    .modal-contents-chip-wrapper {
        top: 17px !important;
    }

    .modal-contents-chip {
        height: 5px !important;
        width: 135px !important;
        background-color: #000000 !important;
    }
}

.swipe-modal-takumaru-vue-swipe-modal.shown .modal-contents {
    bottom: 0 !important;
}
</style>
